import React from 'react';

const Header = () => {
  return (
    <header className="bg-[#000033] py-4 px-6">
      <div className="w-full max-w-full mx-auto">
        <div className="flex items-center justify-between">
          {/* Left Logo */}
          <div className="flex-shrink-0">
            <img 
              src="/images/logos/dav-logo.png" 
              alt="DAV Logo" 
              className="h-24 w-24 object-contain"
            />
          </div>
          
          {/* Center Content */}
          <div className="flex-1 text-center px-4">
            <div className="text-white text-sm mb-1">|| ओ३म् ||</div>
            <div className="text-white text-xs mb-2">|| तमसो मा ज्योतिर्गमय ||</div>
            <h1 className="text-[#FFD700] text-4xl font-bold mb-2">
              D. A. V. VELANKAR COLLEGE OF COMMERCE
            </h1>
            <p className="text-white text-sm">
              Maharshi Dayanand Chowk, Dayanand Nagar, Raviwar peth, Solapur (MS) - 413002
            </p>
            <div className="text-white text-xs mt-2">
              NAAC Reaccredited 'A' (CGPA 3.01) Grad
            </div>
          </div>
          
          {/* Right Logo */}
          <div className="flex-shrink-0">
            <img 
              src="/images/logos/swami-dayanand.jpg" 
              alt="Swami Dayanand" 
              className="h-24 w-24 object-contain"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;